/* import __COLOCATED_TEMPLATE__ from './factoids-collection.hbs'; */
import Component from '@ember/component';
import { computed } from '@ember/object';

export default Component.extend({
  classNames: ['factoids'],

  data: undefined,
  layout: undefined,

  rows: computed('data', 'layout', function() {
    const factoids = this.get('data');
    const layout = this.get('layout');

    return layout.map(row => row.map(factoidLayout => {
      const {title, color} = factoidLayout;
      const factoid = factoids.findBy('title', title);

      if (!factoid) {
        return Object.create({
          title,
          fact: '$0'
        });
      }

      if (color) {
        factoid.set('colorClass', `factoid-color-${color}`);
      }

      return factoid;
    }));
  })
});
